import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const OfflineContext = createContext({ isOffline: false });

export function OfflineProvider({ children }) {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  return (
    <OfflineContext.Provider value={{ isOffline }}>
      {children}
    </OfflineContext.Provider>
  );
}

export function useOffline() {
  return useContext(OfflineContext);
}

/**
 * Hook that returns a guard function for write actions.
 * Call guardWrite() before any create/edit/delete/payment — it returns false + shows toast when offline.
 */
export function useOfflineGuard() {
  const { isOffline } = useOffline();
  const guardWrite = useCallback(() => {
    if (isOffline) {
      // Use a custom event to trigger toast from anywhere
      window.dispatchEvent(new CustomEvent('offline-write-blocked'));
      return false;
    }
    return true;
  }, [isOffline]);

  return { isOffline, guardWrite };
}
